'use client';

import { ReactNode } from 'react';

import {
  ButtonHiddenContainer,
  ButtonLoader,
  ButtonTypography,
  StyledButton,
  StyledOutlinedBlurredButton,
} from './styled';
import { ButtonProps, Variant } from './types';

const renderTypography = (args: {
  children: ReactNode;
  loading?: boolean;
  size: string;
  typography?: Variant;
}) => {
  const { children, loading, typography, size } = args;

  if (loading) {
    return (
      <>
        <ButtonLoader size={15} />
        <ButtonHiddenContainer>{children}</ButtonHiddenContainer>
      </>
    );
  }

  if (typography) {
    return (
      <ButtonTypography component="div" variant={typography} color="inherit">
        {children}
      </ButtonTypography>
    );
  }

  if (size === 'large' || size === 'medium') {
    return (
      <ButtonTypography component="div" variant="button1" color="inherit">
        {children}
      </ButtonTypography>
    );
  }

  if (size === 'small') {
    return (
      <ButtonTypography component="div" variant="button4" color="inherit">
        {children}
      </ButtonTypography>
    );
  }

  return (
    <ButtonTypography component="div" variant="button5" color="inherit">
      {children}
    </ButtonTypography>
  );
};

export const OutlinedBlurredButton = (props: ButtonProps) => {
  const {
    size = 'medium',
    children,
    loading,
    disabled,

    typography,
    ...rest
  } = props;
  const buttonDisabled = loading || disabled;

  return (
    <StyledOutlinedBlurredButton
      disabled={buttonDisabled}
      variant={'outlined'}
      size={size}
      {...rest}
    >
      {renderTypography({ children, typography, size, loading })}
    </StyledOutlinedBlurredButton>
  );
};

export const Button = (props: ButtonProps) => {
  const {
    size = 'medium',
    children,
    loading,
    disabled,
    variant,
    typography,
    ...rest
  } = props;
  const buttonDisabled = loading || disabled;

  return (
    <StyledButton
      disabled={buttonDisabled}
      variant={variant}
      size={size}
      {...rest}
    >
      {renderTypography({ children, typography, size, loading })}
    </StyledButton>
  );
};
